export default {
  status: 0,
  data: [
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '햄버거',
      DIS_ITEM_CD: '00000201',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 1,
      DIS_ITEM_NM: '베이컨클래식\n버거',
      DIS_ITEM_NM_KO: '베이컨클래식\n버거',
      DIS_ITEM_NM_EN: 'Bacon Classic Burger ',
      DIS_ITEM_NM_JP: 'ベーコンクラシックハンバーガー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#BEST',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000201',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/burger/01.img_BaconClassicBurger.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5400,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '클래식하게 즐기는 두툼한 베이컨 클래식버거',
      ITEM_DESC_KO: '클래식하게 즐기는 두툼한 베이컨 클래식버거',
      ITEM_DESC_JP: '肉厚で肉厚なクラシックバーガーをお楽しみください',
      ITEM_DESC_EN: 'Enjoy a classic, thick, beefy classic burger',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '햄버거',
      DIS_ITEM_CD: '00000202',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 2,
      DIS_ITEM_NM: '헤비프라이드\n버거',
      DIS_ITEM_NM_KO: '헤비프라이드\n버거 ',
      DIS_ITEM_NM_EN: 'Heavy Fried Burger',
      DIS_ITEM_NM_JP: 'ヘビーフライバーガー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000202',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/burger/02.img_HeavyFriedBurger.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 6400,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '두툼한 소고기패티와 돼지고기튀김 패티의 만남',
      ITEM_DESC_KO: '두툼한 소고기패티와 돼지고기튀김 패티의 만남',
      ITEM_DESC_JP: 'ふんわりサクサクのハッシュブラウンとチキンパティのハンバーガー',
      ITEM_DESC_EN: 'Combination of thick beef patty and fried pork',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '햄버거',
      DIS_ITEM_CD: '00000203',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 3,
      DIS_ITEM_NM: '2단시그니처\n버거',
      DIS_ITEM_NM_KO: '2단시그니처\n버거',
      DIS_ITEM_NM_EN: '2-tier signature burger',
      DIS_ITEM_NM_JP: '2段シグネチャーバーガー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000203',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/burger/03.img_2-tiersignatureburger.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 7200,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '한우소고기패티가 2단으로 쌓여진 시그니처버거',
      ITEM_DESC_KO: '한우소고기패티가 2단으로 쌓여진 시그니처버거',
      ITEM_DESC_JP: '韓牛パティを2層に重ねた特製バーガー',
      ITEM_DESC_EN: 'Signature burger with two layers of Korean beef patties',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '햄버거',
      DIS_ITEM_CD: '00000204',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 4,
      DIS_ITEM_NM: '3단시그니처\n버거 ',
      DIS_ITEM_NM_KO: '3단시그니처\n버거 ',
      DIS_ITEM_NM_EN: '3-tier signature burger',
      DIS_ITEM_NM_JP: '3段シグネチャーバーガー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000204',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/burger/04.img_3-tiersignatureburger.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 8200,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '한우소고기패티가 3단으로 쌓여진 시그니처버거',
      ITEM_DESC_KO: '한우소고기패티가 3단으로 쌓여진 시그니처버거',
      ITEM_DESC_JP: '韓牛パティを3層に重ねた特製バーガー',
      ITEM_DESC_EN: 'Signature burger with three layers of Korean beef patties',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '햄버거',
      DIS_ITEM_CD: '00000205',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 5,
      DIS_ITEM_NM: '베이컨어니언\n버거',
      DIS_ITEM_NM_KO: '베이컨어니언\n버거',
      DIS_ITEM_NM_EN: 'Bacon Onion Burger',
      DIS_ITEM_NM_JP: 'ベーコンアニオンバーガー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000205',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/burger/05.img_BaconOnionBurger.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 6800,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '허니 홀그레인소스와 베이컨,어니언 조화가 완벽한 베이컨 어니언버거',
      ITEM_DESC_KO: '허니 홀그레인소스와 베이컨,어니언 조화가 완벽한 베이컨 어니언버거',
      ITEM_DESC_JP: 'ハニー全粒ソース、ベーコン、オニオンの組み合わせが絶妙なベーコンオニオンバーガー',
      ITEM_DESC_EN: 'Bacon onion burger with the perfect combination of honey whole grain sauce, bacon, and onion',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '햄버거',
      DIS_ITEM_CD: '00000206',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 6,
      DIS_ITEM_NM: '비프앤치킨\n버거',
      DIS_ITEM_NM_KO: '비프앤치킨\n버거',
      DIS_ITEM_NM_EN: 'Beef and Chicken Burger',
      DIS_ITEM_NM_JP: 'ビーフとチキンバーガー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000206',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/burger/06.img_BeefandChickenBurger.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 7200,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '숯불향이 더해진 소고기패티와 그릴치킨의 매콤한 조합',
      ITEM_DESC_KO: '숯불향이 더해진 소고기패티와 그릴치킨의 매콤한 조합',
      ITEM_DESC_JP: 'ビーフパティと炭火焼きチキンのスパイシーな組み合わせ',
      ITEM_DESC_EN: 'Spicy combination of beef patty and grilled chicken with charcoal flavor',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    /*{
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '햄버거',
      DIS_ITEM_CD: '00000207',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 7,
      DIS_ITEM_NM: '블랙 바베큐버거',
      DIS_ITEM_NM_KO: '블랙 바베큐버거',
      DIS_ITEM_NM_EN: 'Black barbecue burger',
      DIS_ITEM_NM_JP: 'ブラックバーベキューバーガー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000207',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/burger/07.img_Blackbarbecueburger.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 6800,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '미국식 바베큐소스로뒤덮힌 소고기패티와 특별한 먹물빵',
      ITEM_DESC_KO: '미국식 바베큐소스로뒤덮힌 소고기패티와 특별한 먹물빵',
      ITEM_DESC_JP: 'アメリカンバーベキューソースをかけたビーフパティと特製インクパン',
      ITEM_DESC_EN: 'Beef patty covered in American barbecue sauce and special ink bread',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '햄버거',
      DIS_ITEM_CD: '00000208',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 8,
      DIS_ITEM_NM: '더블 치즈버거',
      DIS_ITEM_NM_KO: '더블 치즈버거',
      DIS_ITEM_NM_EN: 'Double Cheeseburger',
      DIS_ITEM_NM_JP: 'ダブルチーズバーガー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000208',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/burger/08.img_Cheeseburger.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 6800,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '패티와치즈가 더블로 추가된 미국식 햄버거',
      ITEM_DESC_KO: '패티와치즈가 더블로 추가된 미국식 햄버거',
      ITEM_DESC_JP: 'ダブルパティとチーズのアメリカンスタイルハンバーガー',
      ITEM_DESC_EN: 'American style hamburger with double patty and cheese',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '햄버거',
      DIS_ITEM_CD: '00000209',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 9,
      DIS_ITEM_NM: '치킨버거',
      DIS_ITEM_NM_KO: '치킨버거',
      DIS_ITEM_NM_EN: 'Chicken Burger',
      DIS_ITEM_NM_JP: 'チキンバーガー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000209',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/burger/09.img_ChickenBurger.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5400,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '부드러운 닭다리살을 통째로 사용한 치킨패티',
      ITEM_DESC_KO: '부드러운 닭다리살을 통째로 사용한 치킨패티',
      ITEM_DESC_JP: '柔らかい鶏もも肉を丸ごと使用したチキンパティ',
      ITEM_DESC_EN: 'Chicken patty made with whole tender chicken thigh meat',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '햄버거',
      DIS_ITEM_CD: '00000210',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 10,
      DIS_ITEM_NM: '피쉬 앤 칩스버거',
      DIS_ITEM_NM_KO: '피쉬 앤 칩스버거',
      DIS_ITEM_NM_EN: 'Fish and Chips Burger',
      DIS_ITEM_NM_JP: '魚フライバーガー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000210',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/burger/10.img_FishandChipsBurger.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 6800,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '깔끔하고 담백,고소한 피쉬튀김과 칩스의 만남',
      ITEM_DESC_KO: '깔끔하고 담백,고소한 피쉬튀김과 칩스의 만남',
      ITEM_DESC_JP: 'ハッシュブラウン、チキンバーガー',
      ITEM_DESC_EN: 'Clean, light, and savory combination of fried fish and chips',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '햄버거',
      DIS_ITEM_CD: '00000211',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 11,
      DIS_ITEM_NM: '해쉬브라운 치킨버거',
      DIS_ITEM_NM_KO: '해쉬브라운 치킨버거',
      DIS_ITEM_NM_EN: 'Hash brown Chicken Burger',
      DIS_ITEM_NM_JP: 'ハッシュブラウン、チキンバーガー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000211',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/burger/11.img_Hashbrownchickenburger.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 6400,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '부드럽고 바삭한 해시브라운에 치킨패티를 더한 햄버거',
      ITEM_DESC_KO: '부드럽고 바삭한 해시브라운에 치킨패티를 더한 햄버거',
      ITEM_DESC_JP: 'ふんわりサクサクのハッシュブラウンとチキンパティのハンバーガー',
      ITEM_DESC_EN: 'Hamburger with soft and crispy hash browns and chicken patty',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    }, */
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '사이드 메뉴',
      DIS_ITEM_CD: '00000212',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 12,
      DIS_ITEM_NM: '비프 스낵랩',
      DIS_ITEM_NM_KO: '비프 스낵랩',
      DIS_ITEM_NM_EN: 'Beef Snack Wrap',
      DIS_ITEM_NM_JP: '牛肉トッティア',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000212',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/sidemenu/01.img_BeefSnackWrap.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 3200,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '간단하고 먹기편한 비프 스낵랩',
      ITEM_DESC_KO: '간단하고 먹기편한 비프 스낵랩',
      ITEM_DESC_JP: 'シンプルで食べやすいビーフスナックラップ',
      ITEM_DESC_EN: 'Simple and easy-to-eat beef snack wrap',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '사이드 메뉴',
      DIS_ITEM_CD: '00000213',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 13,
      DIS_ITEM_NM: '프렌치\n프라이드',
      DIS_ITEM_NM_KO: '프렌치\n프라이드',
      DIS_ITEM_NM_EN: 'French Fries',
      DIS_ITEM_NM_JP: 'フライドポテト',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000213',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/sidemenu/02.img_FrenchFries.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 2100,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '매일 깨끗한 기름에 튀겨 맛있는 감자튀김',
      ITEM_DESC_KO: '매일 깨끗한 기름에 튀겨 맛있는 감자튀김',
      ITEM_DESC_JP: 'きれいな油で毎日揚げるおいしいフライドポテト',
      ITEM_DESC_EN: 'Delicious French fries fried in clean oil every day',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '사이드 메뉴',
      DIS_ITEM_CD: '00000214',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 14,
      DIS_ITEM_NM: '치즈스틱 \n4조각',
      DIS_ITEM_NM_KO: '치즈스틱 \n4조각',
      DIS_ITEM_NM_EN: 'Cheese Stick (4pcs)',
      DIS_ITEM_NM_JP: 'チーズスティック',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000214',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/sidemenu/03.img_CheeseStick.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 2400,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '02,03,06',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '모짜렐라 치즈가 늘어나는 치즈스틱',
      ITEM_DESC_KO: '모짜렐라 치즈가 늘어나는 치즈스틱',
      ITEM_DESC_JP: '増粘モッツァレラチーズ入りチーズスティック',
      ITEM_DESC_EN: 'Cheese sticks with expanded mozzarella cheese',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    /*{
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '사이드 메뉴',
      DIS_ITEM_CD: '00000215',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 15,
      DIS_ITEM_NM: '배지 샐러드',
      DIS_ITEM_NM_KO: '배지 샐러드',
      DIS_ITEM_NM_EN: 'Vege Salad',
      DIS_ITEM_NM_JP: '野菜サラダ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000215',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/sidemenu/04.img_salad-1.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 3400,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '곁들여 먹기 좋은 배지 샐러드',
      ITEM_DESC_KO: '곁들여 먹기 좋은 배지 샐러드',
      ITEM_DESC_JP: '付け合わせにぴったりなバッジサラダ',
      ITEM_DESC_EN: 'Badge salad that is great to eat as a side',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '사이드 메뉴',
      DIS_ITEM_CD: '00000216',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 16,
      DIS_ITEM_NM: '어니언링',
      DIS_ITEM_NM_KO: '어니언링',
      DIS_ITEM_NM_EN: 'Onion Rings',
      DIS_ITEM_NM_JP: 'オニオンリング',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000216',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/sidemenu/05.img_Onion Rings.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 2400,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '양파를 고리 모양으로 썰어 깨끗한 기름에 튀긴 요리',
      ITEM_DESC_KO: '양파를 고리 모양으로 썰어 깨끗한 기름에 튀긴 요리',
      ITEM_DESC_JP: '玉ねぎを輪切りにし、きれいな油で揚げる',
      ITEM_DESC_EN: 'Onion sliced ​​into rings and fried in clean oil',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '사이드 메뉴',
      DIS_ITEM_CD: '00000217',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 17,
      DIS_ITEM_NM: '치킨봉 2조각',
      DIS_ITEM_NM_KO: '치킨봉 2조각',
      DIS_ITEM_NM_EN: 'Chicken Sticks (2pcs)',
      DIS_ITEM_NM_JP: 'チキンボン',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000217',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/sidemenu/06.img_ChickenSticks.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 2000,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '약간 매콤한맛이 나는 바삭한 치킨스틱',
      ITEM_DESC_KO: '약간 매콤한맛이 나는 바삭한 치킨스틱',
      ITEM_DESC_JP: 'ほんのりスパイシーな味わいのクリスピーチキンスティック',
      ITEM_DESC_EN: 'Crispy chicken sticks with a slightly spicy taste',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '사이드 메뉴',
      DIS_ITEM_CD: '00000218',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 18,
      DIS_ITEM_NM: '쉬림프 프라이드',
      DIS_ITEM_NM_KO: '쉬림프 프라이드',
      DIS_ITEM_NM_EN: 'Shrimp Fries',
      DIS_ITEM_NM_JP: 'シュリンプフライ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000218',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/sidemenu/07.img_ShrimpFries.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 3200,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '싱싱한 새우를 사용해 더욱 더 맛있는 새우튀김',
      ITEM_DESC_KO: '싱싱한 새우를 사용해 더욱 더 맛있는 새우튀김',
      ITEM_DESC_JP: '新鮮なエビを使ってさらに美味しいエビフライ',
      ITEM_DESC_EN: 'Even more delicious fried shrimp using fresh shrimp',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },*/
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '사이드 메뉴',
      DIS_ITEM_CD: '00000219',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 19,
      DIS_ITEM_NM: '웨지감자',
      DIS_ITEM_NM_KO: '웨지감자',
      DIS_ITEM_NM_EN: 'Wedge Potato',
      DIS_ITEM_NM_JP: 'ウェッジポテト',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000219',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/sidemenu/08.img_WedgePotato.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 3200,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '매일 깨끗한 기름에 튀겨 맛있는 웨지감자',
      ITEM_DESC_KO: '매일 깨끗한 기름에 튀겨 맛있는 웨지감자',
      ITEM_DESC_JP: '毎日きれいな油で揚げた美味しいウェッジポテト',
      ITEM_DESC_EN: 'Delicious wedge potatoes fried in clean oil every day',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '음료수',
      DIS_ITEM_CD: '00000220',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 20,
      DIS_ITEM_NM: '코카콜라',
      DIS_ITEM_NM_KO: '코카콜라',
      DIS_ITEM_NM_EN: 'Coca Cola',
      DIS_ITEM_NM_JP: 'コカコーラ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#BEST',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000220',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/beverage/01.img_cola.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 2000,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '업소용 음료',
      ITEM_DESC_KO: '업소용 음료',
      ITEM_DESC_JP: '市販の飲料',
      ITEM_DESC_EN: 'commercial beverages',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '음료수',
      DIS_ITEM_CD: '00000221',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 21,
      DIS_ITEM_NM: '스프라이트',
      DIS_ITEM_NM_KO: '스프라이트',
      DIS_ITEM_NM_EN: 'Sprite',
      DIS_ITEM_NM_JP: 'スプライト',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000221',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/beverage/02.img_sprite.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 2000,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '업소용 음료',
      ITEM_DESC_KO: '업소용 음료',
      ITEM_DESC_JP: '市販の飲料',
      ITEM_DESC_EN: 'commercial beverages',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '음료수',
      DIS_ITEM_CD: '00000222',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 22,
      DIS_ITEM_NM: '환타',
      DIS_ITEM_NM_KO: '환타',
      DIS_ITEM_NM_EN: 'Fanta',
      DIS_ITEM_NM_JP: 'ファンタ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000222',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/beverage/03.img_fanta.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 2000,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '업소용 음료',
      ITEM_DESC_KO: '업소용 음료',
      ITEM_DESC_JP: '市販の飲料',
      ITEM_DESC_EN: 'commercial beverages',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '음료수',
      DIS_ITEM_CD: '00000223',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 23,
      DIS_ITEM_NM: '제로콜라',
      DIS_ITEM_NM_KO: '제로콜라',
      DIS_ITEM_NM_EN: 'Zero Cola',
      DIS_ITEM_NM_JP: 'ゼロコーラ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#BEST',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000223',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/food/product/beverage/04.img_zerocola.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 2000,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '업소용 음료',
      ITEM_DESC_KO: '업소용 음료',
      ITEM_DESC_JP: '市販の飲料',
      ITEM_DESC_EN: 'commercial beverages',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
  ],
  message: '',
};
